// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---cache-caches-gatsby-plugin-offline-app-shell-js": () => import("/opt/build/repo/.cache/caches/gatsby-plugin-offline/app-shell.js" /* webpackChunkName: "component---cache-caches-gatsby-plugin-offline-app-shell-js" */),
  "component---src-templates-falter-js": () => import("/opt/build/repo/src/templates/falter.js" /* webpackChunkName: "component---src-templates-falter-js" */),
  "component---src-templates-family-js": () => import("/opt/build/repo/src/templates/family.js" /* webpackChunkName: "component---src-templates-family-js" */),
  "component---src-pages-404-js": () => import("/opt/build/repo/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("/opt/build/repo/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-wer-fliegt-js": () => import("/opt/build/repo/src/pages/wer-fliegt.js" /* webpackChunkName: "component---src-pages-wer-fliegt-js" */)
}

